import React from 'react';
import Modal from 'react-bootstrap/Modal';

import "./infoModal.css";
import PrimaryButton from '../primaryButton/primaryButton';


const InfoModel = (props) => {
    const BodyData = props.bodyData;
    
    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className='info-modal-title'>{props.title}</Modal.Title>
            </Modal.Header>
            
                {
                    BodyData &&
                    <Modal.Body>
                        <BodyData />
                    </Modal.Body>
                }
            
            <Modal.Footer>
                <PrimaryButton
                    text="Close"
                    customStyle={{ width: "80px", backgroundColor: "#707683" }}
                    onClick={props.handleClose}
                />
                <PrimaryButton
                    text={props.saveButtonText}
                    onClick={props.handleSave}
                />
            </Modal.Footer>
        </Modal>
    );
}

export default InfoModel;
